import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IGetUsuarios } from './gestao-acesso-layout.model';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import moment from 'moment';
import { AppExportBase64 } from '../../../services/exportBase64/exportBase64.service';
import { PermissionService } from '../../../services/permission.service';
import { HttpService } from '../../../services/common/http/common.http.service';
import { formatTel } from '../../../utils/utility-functions';
@Component({
  selector: 'app-gestao-acesso-layout',
  templateUrl: './gestao-acesso-layout.component.html',
  styleUrls: ['./gestao-acesso-layout.component.scss'],
})
export class GestaoAcessoLayoutComponent implements OnInit {
  permission: number = 2;
  usuarios: any = [];
  perfilData = [];
  pesquisaParam: string = '';
  expandirCardsMobile: boolean = false;
  loader: boolean = false;

  constructor(
    private httpService: HttpService,
    private permissionService: PermissionService,
    private router: Router,
    private toast: ToastrService,
    private exportBase64Service: AppExportBase64,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.permission = this.permissionService.getPermission();
    this.getPerfils();
    this.getUsuarios();
    this.changeDetectorRef.detectChanges();
  }

  form = {
    pesquisar: '',
  };

  tableColumns = [
    {
      header: 'Nome e E-mail',
      key: '',
      keyArray: ['nome', 'email'],
      type: 'textArray',
    },
    { header: 'Telefone', key: 'telefone', type: 'text' },
    { header: 'Perfil', key: 'perfil', type: 'text' },
    { header: 'Data de Criação', key: 'dataCriacao', type: 'text' },
    {
      header: 'Suspender',
      key: 'suspender',
      type: 'switch',
      action: (item: any) => this.suspenderFuncionario(item),
      condition: (item: any) => true,
    },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Editar',
          img: 'assets/images/edit.svg',
          action: (item: any) => this.editItem(item),
          condition: (item: any) => true,
        },
        {
          label: 'Deletar',
          img: 'assets/images/del.svg',
          action: (item: any) => this.deleteItem(item),
          condition: (item: any) => true,
        },
      ],
    },
  ];

  rowsMobile = [
    { header: 'Nome', key: 'nome', type: 'text', default: true },
    {
      header: 'E-mail',
      key: 'email',
      type: 'text',
      default: true,
      style: 'blue',
    },
    { header: 'Perfil', key: 'perfil', type: 'text', default: true },
    { header: 'Telefone', key: 'telefone', type: 'text' },
    { header: 'Data de Criação', key: 'dataCriacao', type: 'text' },
    {
      header: 'Suspender',
      key: 'suspender',
      type: 'switch',
      action: (item: any) => this.suspenderFuncionario(item),
      condition: (item: any) => true,
    },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Editar',
          img: 'assets/images/edit.svg',
          action: (item: any) => this.editItem(item),
          condition: (item: any) => true,
        },
        {
          label: 'Deletar',
          img: 'assets/images/del.svg',
          action: (item: any) => this.deleteItem(item),
          condition: (item: any) => true,
        },
      ],
    },
  ];

  editItem(item: any) {
    this.router.navigate(['recursos-humanos/gestao-de-acesso/editar-usuario'], {
      queryParams: item,
    });
  }

  getPerfils() {
    this.loader = true;

    this.httpService.useGet('Perfil').subscribe({
      next: (response: any) => {
        this.perfilData = response.map((item: any) => ({
          name: item.TxNomePerfil,
          value: item.IdPerfil,
        }));

        this.loader = false;
      },
      error: () => {},
      complete: () => {},
    });
  }

  deleteItem(item: any) {
    this.loader = true;
    const id = item.idFuncionario;
    const body = {
      IdFuncionario: id,
      NuStatusFuncionario: 1,
    };

    this.httpService.usePatch('FuncionarioStatus', body, id).subscribe(
      (response) => {
        Swal.fire({
          title: 'Sucesso!',
          text: ` Exclusão realizada com sucesso.`,
          icon: 'success',
          confirmButtonColor: 'green',
          confirmButtonText: 'Ok',
        });

        this.getUsuarios();

        this.loader = false;
      },
      (error) => {
        Swal.fire({
          title: 'Alerta!',
          text: 'Ocorreu uma falha no processo de suspensão / reativação, tente novamente.',
          icon: 'error',
          confirmButtonColor: 'green',
          confirmButtonText: 'Ok',
        });

        this.loader = false;
      }
    );
  }

  criarUsuario() {
    this.router.navigate(['recursos-humanos/gestao-de-acesso/criar-usuario']);
  }

  pesquisar(value: string) {
    this.pesquisaParam = `?txPesquisar=${value}`;
    this.getUsuarios();
  }

  exportExcel() {
    this.loader = true;
    const body = {};

    this.httpService.useGet('FuncionarioByFilterXlsx', body).subscribe({
      next: (response: any) => {
        this.exportBase64Service.downloadExcel(
          response.DataSet.XlsxBase64,
          'gestao-acesso'
        );
        this.loader = false;
      },
      error: (_error) => {
        this.toast.success(
          'Ocorreu um erro ao exportar excel. Tente novamente!'
        );
        this.loader = false;
      },
    });
  }

  getDate(date: Date) {
    if (date !== null) {
      return moment(date).format('DD/MM/YYYY');
    }
    return '--';
  }

  getUsuarios() {
    const txPesquisar = this.form.pesquisar;
    this.httpService.useGet('FuncionarioByFilter', { txPesquisar }).subscribe({
      next: (response: any) => {
        this.usuarios = response.DataSet.map((item: IGetUsuarios) => {
          const perfil: any = this.perfilData.find(
            (perfil: any) => perfil.value === item.Perfil.IdPerfil
          );
          return {
            idFuncionario: item.FuncionarioId,
            idUsuario: item.IdUsuario,
            idPerfil: item.Perfil.IdPerfil,
            nome: item.TxNome,
            email: item.TxEmail,
            telefone: formatTel(item.TxTeleFuncionario),
            perfil: perfil?.name ?? '--',
            dataCriacao: this.getDate(item.DtCriacao),
            status: item.NuStatus,
            bloqueio: item.DtExclusao === null ? 'Desbloqueado' : 'Bloqueado',
            suspender: item.NuStatus == 2 ? false : true,
          };
        });
        this.router.navigate(['recursos-humanos/gestao-de-acesso']);
      },
      error: () => {},
      complete: () => {},
    });
  }

  suspenderFuncionario(item: any) {
    let statusPessoa: number;
    const body = {
      IdFuncionario: 0,
      NuStatusFuncionario: 1,
    };

    statusPessoa = item.status == 2 ? 3 : 2;
    let id = item.idFuncionario;

    body.IdFuncionario = id;
    body.NuStatusFuncionario = statusPessoa;

    this.httpService.usePatch('FuncionarioStatus', body, id).subscribe(
      (response) => {
        Swal.fire({
          title: 'Sucesso!',
          text: `${
            statusPessoa == 2 ? 'Remoção da suspensão' : 'Suspensão'
          } realizada com sucesso.`,
          icon: 'success',
          confirmButtonColor: 'green',
          confirmButtonText: 'Ok',
        }).then((result) => {
          if (result.isConfirmed) {
            this.getUsuarios();
          }
        });
      },
      (error) => {
        Swal.fire({
          title: 'Alerta!',
          text: 'Ocorreu uma falha no processo de suspensão / reativação, tente novamente.',
          icon: 'error',
          confirmButtonColor: 'green',
          confirmButtonText: 'Ok',
        });
      }
    );
  }

  timer: ReturnType<typeof setTimeout> | null = null;
  onChangeSearch() {
    if (this.timer !== null) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      this.getPerfils();
    }, 800);
  }
}
